import * as R from 'ramda';

export const mapBonusesPerPaymentMethodsToBonusSelectionList = (bonuses = {}) =>
  R.compose(
    R.values,
    R.mapObjIndexed((val, key) => ({ ...val, value: key }))
  )(bonuses);

export const defineUnavailableBonusTypes = (availableBonusesPerDepAmount = [], allBonuses = []) =>
  R.compose(
    R.map(R.assoc('disabled', true)),
    R.filter(item => !R.find(R.propEq('value', item.value), availableBonusesPerDepAmount)),
  )(allBonuses);
